import styled from 'styled-components';

const DesignerLink = styled.a`
  font-size: 15px;
  color: #000;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: #000;
  }
`;

export default DesignerLink;
